module.exports = __webpack_public_path__ + "img/icon1.cca3ea4b.png";